"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTypeStyles = void 0;
var _TypeModule = _interopRequireDefault(require("./Type.module.css"));
var useTypeStyles = function useTypeStyles() {
  return {
    className: _TypeModule.default.type
  };
};
exports.useTypeStyles = useTypeStyles;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VUeXBlU3R5bGVzIiwiY2xhc3NOYW1lIiwic3R5bGVzIiwidHlwZSJdLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1R5cGUvdXNlVHlwZVN0eWxlcy50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgdHlwZSB7IENsYXNzTmFtZXNBbmRTdHlsZXNPYmplY3QgfSBmcm9tICdAbmVyZHdhbGxldC9iYXNlLXN0eWxlcy9yZWFjdCc7XG5cbmltcG9ydCBzdHlsZXMgZnJvbSAnLi9UeXBlLm1vZHVsZS5sZXNzJztcblxuZXhwb3J0IHR5cGUgVXNlVHlwZVN0eWxlc0Z1bmN0aW9uID0gKCkgPT4gQ2xhc3NOYW1lc0FuZFN0eWxlc09iamVjdDtcblxuZXhwb3J0IGNvbnN0IHVzZVR5cGVTdHlsZXM6IFVzZVR5cGVTdHlsZXNGdW5jdGlvbiA9ICgpID0+IHtcbiAgcmV0dXJuIHtcbiAgICBjbGFzc05hbWU6IHN0eWxlcy50eXBlLFxuICB9O1xufTtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUVBO0FBSU8sSUFBTUEsYUFBb0MsR0FBRyxTQUF2Q0EsYUFBb0MsR0FBUztFQUN4RCxPQUFPO0lBQ0xDLFNBQVMsRUFBRUMsbUJBQU0sQ0FBQ0M7RUFDcEIsQ0FBQztBQUNILENBQUM7QUFBQyJ9